export interface CheckLendExtendRequestCollection {
  id: number
  extendDueDate: string
  revision: number
}

export function CheckLendExtendRequestCollectionToJSON(
  value: CheckLendExtendRequestCollection
): any {
  return {
    id: value.id,
    extend_due_date: value.extendDueDate,
    revision: value.revision
  }
}
